import React from 'react';
import {Image, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {HEADING_BORDER_WIDTH, HEADING_FONT_SIZE} from "../../Config/Constants";
import {BORDER_COLOR, HEADING_TITLE_COLOR} from "../../Config/Colors";
import HeaderTypes from "../../Domain/Types/HeaderTypes";
import {HEADER_TITLES} from "../../Config/Translations";
import OrderIcon from "../../Images/Icons/order.png";
import {powerProxyRepository} from "../../Domain/Repositories/PowerProxyRepository";

const headerItems = [
    HeaderTypes.None,
    HeaderTypes.ProxyName,
    HeaderTypes.ProxyId,
    HeaderTypes.ConnectionStatus,
    HeaderTypes.None,
];

const flex = [0.17, 1, 1, 1, 0.17];

/**
 * Renders the Proxy List Header.
 */
export default function ProxyListHeader()
{
    const renderHeaderItems = (): JSX.Element[] =>
    {
        return headerItems.map((header: HeaderTypes, index: number) =>
        {
            return (
                <View
                    style={[styles.headingTextView, {
                        flex: flex[index],
                    }]}
                    key={`${header}-${index}`}
                >
                    <View style={styles.textHeaderContainer}>
                        <View style={styles.textHeaderView}>
                            <Text style={styles.headingText}>
                                {HEADER_TITLES(header)}
                            </Text>
                        </View>

                        {header !== HeaderTypes.None && (
                            <View style={styles.orderByView}>
                                <TouchableOpacity
                                    style={styles.orderByButton}
                                    onPress={() => {
                                        powerProxyRepository.updateOrder(header);
                                    }}
                                >
                                    <Image
                                        source={OrderIcon}
                                        resizeMode={"contain"}
                                        style={styles.icon}
                                    />
                                </TouchableOpacity>
                            </View>)}
                    </View>
                </View>
            )
        })
    }
    
    return (
        <View style={styles.header}>
            {renderHeaderItems()}
        </View>
    );
}

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        width: '100%',
        flex: 0.09,
    },
    headingTextView: {
        flex: 1,
        justifyContent: 'center',
        backgroundColor: BORDER_COLOR,
        alignItems: 'center',
        borderColor: BORDER_COLOR,
        borderWidth: HEADING_BORDER_WIDTH,
    },
    headingText: {
        color: HEADING_TITLE_COLOR,
        fontSize: HEADING_FONT_SIZE,
        fontWeight: "600",
        textAlign: 'left',
        paddingLeft: '5%',
        width: '100%',
    },
    checkBox: {
        width: '55%',
        height: undefined,
        aspectRatio: 1,
    },
    textHeaderContainer: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
    },
    textHeaderView: {
        flex: 5,
        height: '100%',
        justifyContent: 'center',
    },
    orderByView: {
        flex: 1,
        height: '100%',
        justifyContent: 'center',
    },
    orderByButton: {
        width: '100%',
        height: undefined,
        aspectRatio: 1,
        justifyContent: 'center',
    },
    icon: {
        width: undefined,
        height: '40%',
        aspectRatio: 1,
        alignSelf: 'center',
    },
});
